import {
  generateAccentPalette,
  generateDarkPalette,
  generateLightPalette,
  HSLColor,
} from '@yola/yola-palette-generator';
import { rules, utils } from '@yola/ws-color-rules';
import helpers from './helpers';
import { PALETTE_KEY } from './constants/common';

const { increaseColorPointByStep, reduceColorPointByStep } = utils;
const { initAssignVariable, parseTemplate, parseColors } = helpers;

const generateColorPalette = ({ config, colors }) => {
  const {
    light,
    altLight,
    dark,
    altDark,
    primary,
    secondary,
    error = new HSLColor(351, 1, 0.96),
    warning = new HSLColor(46, 1, 0.94),
    success = new HSLColor(127, 0.47, 0.93),
    info = new HSLColor(199, 0.94, 0.94),
    whiteColor = new HSLColor(0, 0, 1),
    blackColor = new HSLColor(0, 0, 0),
    advancedColors: customAdvancedColors = {},
  } = colors;

  const palettes = {
    [`light${PALETTE_KEY}`]: generateLightPalette(light),
    [`altLight${PALETTE_KEY}`]: generateLightPalette(altLight),
    [`dark${PALETTE_KEY}`]: generateDarkPalette(dark),
    [`altDark${PALETTE_KEY}`]: generateDarkPalette(altDark),
    [`primary${PALETTE_KEY}`]: generateAccentPalette(primary),
    [`secondary${PALETTE_KEY}`]: generateAccentPalette(secondary),
    [`error${PALETTE_KEY}`]: generateAccentPalette(error),
    [`warning${PALETTE_KEY}`]: generateAccentPalette(warning),
    [`success${PALETTE_KEY}`]: generateAccentPalette(success),
    [`info${PALETTE_KEY}`]: generateAccentPalette(info),
  };

  const context = {
    ...colors,
    ...palettes,
    whiteColor,
    blackColor,
    rules,
    label: config.label,
    increaseColorPointByStep,
    reduceColorPointByStep,
    assignVariable: initAssignVariable({
      cssVariablesMap: config.cssVariablesMap,
      palettes,
      whiteColor,
      blackColor,
      advancedColors: customAdvancedColors,
    }),
  };

  const advancedColors = parseColors(config.advancedColorsTemplate, context, customAdvancedColors);

  const colorPalette = parseTemplate(config.template, {
    ...context,
    ...advancedColors,
  });

  return {
    ...colorPalette,
    advancedColors: Object.entries(customAdvancedColors).reduce((acc, [colorKey, hslColor]) => {
      acc[colorKey] = hslColor.toCSSValue();
      return acc;
    }, {}),
  };
};

export default generateColorPalette;
